module.exports = __webpack_public_path__ + "static/img/reward_anchor_img.8ddf5e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reward_anchor_img.png
// module id = nn3u
// module chunks = 0